import { FlexProps, Flex } from '@chakra-ui/react';

const ProductFieldContent = (props: FlexProps) => <Flex flex={5} {...props} />;

export default ProductFieldContent;
